import { takeLatest } from 'redux-saga/effects';
import { notifierWorkerCreator } from '@common/utils/notifier/notifier-worker-creator';
import { ErrorAPI, Notify, NotifyDurationInSecond } from '@common/types';
import { EMPTY_STRING } from '@common/constants';
import { plannerRoutinesWithNotifier } from '@modules/planning/actions';
import { defaultStatuses, PlannerAction } from '@modules/planning/constants';
import { getErrorMessage } from '@common/utils/helpers/notifier/get-error-message';

/**Метод получения текста уведомления для разных actions*/
const getDataNotificationMessage = (
  action: PlannerAction,
  type: Notify.Loading | Notify.Error | Notify.Success,
  payload?: { message: string; hideSuccessMessage?: boolean }
): string => {
  if (payload?.hideSuccessMessage) return EMPTY_STRING;
  return payload?.message || defaultStatuses[action][type] || EMPTY_STRING;
};

export default getDataNotificationMessage;

const getActionFromRoutine = (actionName: string): PlannerAction => {
  return actionName as PlannerAction;
};

const worker = notifierWorkerCreator<{ message: string; hideSuccessMessage?: boolean }, PlannerAction>({
  getActionFromRoutine,
  getKeyPrefix: () => 'PLANNER',
  getNotificationMessage: getDataNotificationMessage,
  successDuration: NotifyDurationInSecond.Two
});

const errorWorker = notifierWorkerCreator<ErrorAPI, PlannerAction>({
  getActionFromRoutine,
  getKeyPrefix: () => 'PLANNER',
  getNotificationMessage: () => EMPTY_STRING,
  getErrorMessage
});

export function* plannerNotifierWatcher() {
  for (let routine of plannerRoutinesWithNotifier) {
    yield takeLatest(routine.SUCCESS, worker);
    yield takeLatest(routine.REQUEST, worker);
    yield takeLatest(routine.FAILURE, errorWorker);
  }
}
